/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/** Per-entity permissions for a single UTUT row, keyed by `${aem_id}%#%${status}`. */
export interface UtutEntityPermissions {
    canPublish: boolean;
    canSendToLoc: boolean;
    canRefresh: boolean;
    canArchive: boolean;
    canUnarchive: boolean;
}

/** UTUT dashboard permission state: a map from entity key to its allowed actions. */
export interface UtutPermissionState {
    permissions: Record<string, UtutEntityPermissions>;
}

/** Reset value for Redux / unmount cleanup */
export const EMPTY_UTUT_PERMISSION_STATE: UtutPermissionState = {
    permissions: {},
};
